import { c as _c } from "react/compiler-runtime";
export function InfoCard(t0) {
  const $ = _c(12);
  const {
    icon,
    title,
    subtitle
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <div className="w-[72px] h-[72px] rounded-full bg-surface-weak flex items-center justify-center">{icon}</div>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <h2 className="text-[22px] text-surface-foreground tracking-[-0.275px] leading-normal">{title}</h2>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== subtitle) {
    t3 = <p className="text-sm text-surface-foreground-weak tracking-[-0.21px] leading-[1.4]">{subtitle}</p>;
    $[4] = subtitle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-col gap-1">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <div className="flex flex-col gap-4">{t1}{t4}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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